/* PureEthical v30 - fundo das fotos igual em todos os produtos.

   As fotos ficam sobre o fundo areia com mix-blend-mode:multiply: o branco puro (255) desaparece
   e fica areia. Mas algumas fotos (ex.: Desigual, fotos com modelo) tem fundo quase branco
   (235-250) em vez de branco puro, e com o multiply isso aparece como um quadrado um pouco mais
   escuro dentro do cartao.

   O que faz: para cada foto com fundo claro e neutro (cantos cinzento-claro, quase brancos),
   aplica um filtro que leva so os tons a partir do tom do fundo a branco puro; abaixo disso a foto
   fica igual. Assim o fundo desaparece como nas outras. Fotos com fundo branco puro, colorido ou
   escuro nao sao tocadas. Nao altera as imagens na Shopify - so a forma como sao mostradas. */
(function () {
  var NS = 'http://www.w3.org/2000/svg', made = {}, svg = null, cv = null, cx = null;
  var SEL = '.pc-media img, .pe-hero-img img, #prodGallery img, .pe-home-cats img, .pe-sg-img img, .pe-mcomp-cell img, .pw-hero-m img, .pw-tile-m img, .nh-bw-img, .cd-item-img img, .pcp-img img, .qv-img img, #qaImg, .pe-mc-thumb img, .pc-vthumb img, .wl-item-img img';
  /* v42: mais sitios com fundo cinza (pagina inicial, marcas, cesto, vista rapida, menu) - o fundo fica exatamente igual em todo o lado */

  function filterFor(t) {
    var id = 'pe-wp-' + t;
    if (made[id]) return id;
    if (!svg) {
      svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('width', '0'); svg.setAttribute('height', '0');
      svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
      document.body.appendChild(svg);
    }
    /* curva: igual ate (t-14), sobe suavemente ate branco em t, branco acima de t */
    var v = [], a = t - 14;
    for (var i = 0; i < 256; i++) {
      var o = i < a ? i : (i >= t ? 255 : a + (i - a) * (255 - a) / (t - a));
      v.push((o / 255).toFixed(4));
    }
    var f = document.createElementNS(NS, 'filter');
    f.setAttribute('id', id);
    f.setAttribute('color-interpolation-filters', 'sRGB');
    var ct = document.createElementNS(NS, 'feComponentTransfer');
    ['feFuncR', 'feFuncG', 'feFuncB'].forEach(function (n) {
      var fn = document.createElementNS(NS, n);
      fn.setAttribute('type', 'table');
      fn.setAttribute('tableValues', v.join(' '));
      ct.appendChild(fn);
    });
    f.appendChild(ct);
    svg.appendChild(f);
    made[id] = 1;
    return id;
  }

  function check(img) {
    if (img.getAttribute('data-pe-bg')) return;
    if (!img.complete || !img.naturalWidth) return;
    /* v43: fotografias de campanha (pagina inicial) ficam como estao - o filtro e so para fotos de produto */
    if (img.closest && img.closest('.pw-hero--photo, .pw-tile--photo')) return;
    img.setAttribute('data-pe-bg', '1');
    try {
      if (!cv) { cv = document.createElement('canvas'); cv.width = 24; cv.height = 30; cx = cv.getContext('2d', { willReadFrequently: true }); }
      cx.clearRect(0, 0, 24, 30);
      cx.drawImage(img, 0, 0, 24, 30);
      var pts = [[0, 0], [23, 0], [0, 29], [23, 29]], mn = 255, spread = 0;
      for (var i = 0; i < pts.length; i++) {
        var d = cx.getImageData(pts[i][0], pts[i][1], 1, 1).data;
        mn = Math.min(mn, d[0], d[1], d[2]);
        spread = Math.max(spread, Math.max(d[0], d[1], d[2]) - Math.min(d[0], d[1], d[2]));
      }
      /* so fundos claros e neutros que nao sao ja branco puro */
      if (mn >= 253 || mn < 218 || spread > 8) return;
      var t = Math.max(218, mn - 3);
      img.style.setProperty('filter', 'url(#' + filterFor(t) + ')', 'important');
      img.setAttribute('data-pe-bg', String(t));
    } catch (e) { /* imagem de outro dominio: fica como esta */ }
  }

  function scan(root) {
    var list = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) {
      var im = list[i];
      if (im.complete && im.naturalWidth) check(im); /* as que ainda carregam passam pelo 'load' abaixo */
    }
  }

  function boot() {
    scan(document);
    /* imagens que mudam de src (srcset, troca de cor) voltam a ser verificadas */
    document.addEventListener('load', function (e) {
      var t = e.target;
      if (t && t.tagName === 'IMG' && t.matches && t.matches(SEL)) { t.removeAttribute('data-pe-bg'); t.style.removeProperty('filter'); check(t); }
    }, true);
    if (window.MutationObserver) {
      var tm = null;
      new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(function () { scan(document); }, 120); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
